<template>
  <div class="step flex flex-auto relative">
    <div class="absolute yellow-brush pointer-events-none">
      <img src="@/assets/yellow-brush.svg" alt="" />
    </div>
    <div class="absolute blue-circles pointer-events-none">
      <img src="@/assets/blue-circles.svg" alt="" />
    </div>

    <!-- Step stuff -->
    <div class="fade-in flex flex-auto">
      <div class="flex flex-auto flex-col">
        <header class="step__header">
          <div class="max-w-xl text-center mx-auto">
            <IconHeading class="u-h1" :heading="heading" />
          </div>
        </header>

        <div
          class="step__content flex-auto flex flex-col justify-center sm:px-4 mb-8"
        >
          <slot name="content" />
        </div>

        <div
          class="flex flex-col sm:flex-row justify-center step-buttons -ml-6 -mb-3"
        >
          <div v-if="$root.backButtonShown" class="pl-6 pb-3">
            <button class="c-btn c-btn--outline" @click="$root.prevStep">
              {{ $root.backButtonText }}
            </button>
          </div>
          <div class="pl-6 pb-3">
            <button class="c-btn c-btn--accent" @click="$root.nextStep">
              {{ $root.nextButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconHeading from '@/components/IconHeading.vue';

export default {
  name: 'Step',
  components: { IconHeading },
  props: ['heading', 'stepNumber'],
};
</script>

<style lang="scss">
$sm: 640px;
$md: 768px;
$lg: 1024px;
$xl: 1280px;

$borderGrey: #cccdda;

input,
select {
  border: 1px solid $borderGrey;
  border-radius: 5px;
  height: 50px;
  padding-left: 2rem !important;
  padding-right: 2rem !important;
  width: 100%;
  display: block;

  &:focus {
    border: 1px solid darken($borderGrey, 10%);
  }
}

select {
  @apply appearance-none;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='8' height='7' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath transform='rotate(-180 190.75 15.5)' fill='%236062FF' fill-rule='evenodd' d='M377.5 24.3536576L381.5 30.6463424 373.5 30.6463424z'/%3E%3C/svg%3E");
  background-position: calc(100% - 21px) 50%;
  background-repeat: no-repeat;
  /* font-size: 20px !important; */
}

.step {
  @apply h-full w-full mx-auto mb-12;
  box-shadow: 0px 31px 36px rgba(17, 17, 18, 0.06);
  border-radius: 5px;

  max-width: 1096px;
  background: white;
  flex: 1 1 auto;
  padding: 40px 20px;

  @screen sm {
    padding: 60px 35px;
    border-radius: 4px;
  }
  @screen lg {
    padding: 60px;
  }

  .step__header {
    border-bottom: 2px solid #edeff6;
    @apply px-4 pb-8 mb-8;
    @screen sm {
      @apply px-0;
    }
  }
}

.q-and-a {
  @apply flex flex-col justify-between mb-4;

  @screen md {
    @apply flex-row items-center;
  }

  .question {
    @apply flex-auto max-w-lg;
    @screen md {
      @apply mr-16;
    }
  }

  .answer {
    @apply mt-4 flex-auto;

    @screen md {
      @apply mt-0;
      flex: 0 0 200px;
    }
    > * {
      width: 100%;
    }
  }

  /* Block Layout */
  &.q-and-a--block {
    @apply text-center items-center py-12;
    @screen md {
      @apply flex-col items-center justify-center;
    }
    .question {
      margin-right: 0 !important;
      @apply mb-8 max-w-xl;
    }
    .answer {
      flex: 0 0 auto !important;
    }
  }
}

.step-buttons {
  > * {
    @screen md {
      min-width: 293px;
    }
    .c-btn {
      @apply w-full;
    }
  }
}

.yellow-brush {
  bottom: 10%;
  left: -5%;
  display: none;
  @screen sm {
    display: block;
  }
}
.blue-circles {
  top: 8%;
  right: -5%;
  display: none;
  @screen sm {
    display: block;
  }
}
</style>
